import {ChangeDetectionStrategy, ChangeDetectorRef, Component} from '@angular/core';
import {AppLoadingEventsEmitter} from '../../events/loading.events';
import {UsersService} from '../../services/users.service';
import {LocalisationService} from '../../services/localisation.service';
import {Languages} from '../../enums/languages';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterComponent {

    constructor(
        private readonly changeDetectorRef: ChangeDetectorRef,
        private readonly usersService: UsersService,
        private readonly appLoadingEventsEmitter: AppLoadingEventsEmitter,
        private readonly localisationService: LocalisationService,
    ) {
    }

    copyUrl() {
        this.appLoadingEventsEmitter.broadcastAppIsLoading(true);

        this.usersService.getUserProfile().subscribe(profile => {
            const el = document.createElement('textarea');
            el.value = 'https://agaia.life/' + (this.localisationService.getLanguage() === Languages.English ? 'en/' : '') + profile.referral_name;
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
            this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
        }, () => {
            this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
        });
    }

}
